module.exports = __webpack_public_path__ + "static/media/led.f1706997.png";